import React from 'react';
import { locale, } from '../../../jsCore/providers/i18nProvider/i18nProvider';
const blockName = 'mobile-match-date-component';
const DATE_FORMAT = { month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit', };
export default function MobileMatchDate({ date, }){
  const dateAndTimeStr = date.toLocaleString(locale, DATE_FORMAT);
  return (
    <div className={ blockName }>
      { dateAndTimeStr }
    </div>
  );
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/schedule/components/mobileMatchDate.js